<template>
    <el-dialog
        title="使用介绍"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false">
        <el-form :model="form" ref="form" label-width="auto" class="demo-ruleForm">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="工具名称">
                        <el-input v-model="form.name" size="small" placeholder="请输入工具名称" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="工具最新版本">
                        <el-input v-model="form.lastVersionName" size="small" placeholder="请输入工具最新版本" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="简介">
                <el-input type="textarea" :rows="2" size="small" v-model="form.introduction" placeholder="请输入简介" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="使用介绍">
                <div class="wangeditor-box">
                    <div id="websiteEditorElem" class="editor-wrap" ref="editor"></div>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="medium" @click="save">保存</el-button>
            <el-button size="medium" @click="closeDialog">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import E from 'wangeditor'
export default {
    props:{
        vkey: {
            type: String
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                name: '',
                lastVersionName: '',
                introduction: '',
                description: ''
            },
            editor: null,
        };
    },
    methods: {
        show(row) {
            this.dialogVisible = true;

            // 获取详情
            this.$store.dispatch('manage/public', {
                query: row.id,
                requestInterfaceName: 'toolDetailInfo'
            }).then(res=>{
                if(res.code == 0) {
                    this.form = {
                        id: res.data.id,
                        name: res.data.name,
                        lastVersionName: res.data.lastVersionName,
                        introduction: res.data.introduction,
                        description: res.data.description
                    }

                    if(!this.editor) {
                        this.initE();
                    }

                    if(this.form.description) {
                        this.editor.txt.html(this.form.description);
                    } else {
                        this.editor.txt.html('<p><br></p>') 
                    }
                }
            })
          
        },
        initE() {
            this.editor = new E(this.$refs.editor);
            // 关闭粘贴样式的过滤
            this.editor.config.pasteFilterStyle = false;
            this.editor.config.fontSizes = {
              'x-small': { name: '12px', value:'1'},
              'small': { name: '13px', value:'2'},
              'normal': { name: '14px', value:'3'},
              'large': { name: '15px', value:'4'},
              'xx-large': { name: '16px', value:'5'},
              'xxx-large': { name: '17px', value:'6'},
            };
            this.editor.config.customUploadImg = (files, insert) => {
                // files 是 input 中选中的文件列表     
                // insert 是获取图片 url 后，插入到编辑器的方法   
                var fd = new FormData();
                files.forEach((item) => {
                    fd.append('file', item); // 上传的文件： 键名，键值     
                    // base64格式  
                    let reader = new FileReader();
                    reader.onload = function () {
                        // 上传代码返回结果之后，将图片插入到编辑器中      
                        insert(reader.result)
                    }
                    reader.readAsDataURL(item);
                })
            }
            this.editor.config.onchange = (html) => {
                this.form.description = html;
            };
            // 失去焦点的回调
            this.editor.config.onblur = function (newHtml) {
                // 获取最新的 html 内容
                // console.log('onblur', newHtml)
            }
            //获取焦点的回调
            this.editor.config.onfocus = function (newHtml) {
                // 获取最新的 html 内容
                // console.log('onfocus', newHtml)
            }
            // 创建一个富文本编辑器
            this.editor.create();
        },
        // 保存
        save() {
            this.$store.dispatch('manage/edit', {
                vkey: this.vkey,
                query: this.form,
                requestInterfaceName: 'editToolData',
                listInterfaceName: 'getToolList'
            }).then(res=>{
                if(res.code == 0) {
                    this.$message.success('保存成功');
                    this.$parent.formInline.pageNum = 1;
                } else {
                    this.$message.error(res.message);
                }
                this.closeDialog();
            })
        },
        closeDialog() {
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>

</style>